import { colors, CTASecondaryHyperlink, GoodSansB2, QueensH2 } from '@components/shared'
import * as React from 'react'
import { Col, config, Container, Row } from 'react-awesome-styled-grid'
import styled from 'styled-components'
type PropsType = {
  takeMeThere: (id: string) => void
}

export default function AboutSubMenu (props: PropsType): React.ReactNode {
  return (
    <Container>
      <Row justify='center'>
        <Col align='center'>
          <Header>
            Stories made by women—for everyone.
          </Header>
          <Description>
            We're building an inclusive universe of erotic audio stories, where the female gaze is always front and center. Curious? Keep reading.
          </Description>
          <IntroButtonContainer>
            <IntroButton
              role='button'
              tabIndex='0'
              onClick={(): void => props.takeMeThere('our-beliefs')}
              onKeyDown={(event: any): void => {
                if (event.keyCode === 13) {
                  props.takeMeThere('our-beliefs')
                }
              }}
            >
              WHAT WE DO
            </IntroButton>
            <IntroButton
              role='button'
              tabIndex='0'
              onClick={(): void => props.takeMeThere('our-people')}
              onKeyDown={(event: any): void => {
                if (event.keyCode === 13) {
                  props.takeMeThere('our-people')
                }
              }}
            >
              WHO WE ARE
            </IntroButton>
          </IntroButtonContainer>
        </Col>
      </Row>
    </Container>
  )
}

const IntroButtonContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${(props: any): any => config(props).media.md`
    flex-direction: row;
    justify-content: center;
    > a:first-child {
      margin-left: 0;
    }
    > a:last-child {
      margin-right: 0;
    }
  `}
  ${(props: any): any => config(props).media.lg`
    margin: 0 auto;
  `}
  ${(props: any): any => config(props).media.xl`
    margin: 0 auto;
  `}
`

const IntroButton = styled(CTASecondaryHyperlink)<any>`
  color: ${colors.sand};
  border: 1px solid ${colors.sand};
  margin: 0 0 15px;
  ${(props: any): any => config(props).media.md`
    padding:  0 30px;
    margin: 0 10px;
    min-width: 200px;
  `}
  ${(props: any): any => config(props).media.xl`
    padding:  0 46px;
    margin: 0 20px;
  `}
`
const Header = styled.h1<any>`
  ${QueensH2}
  text-align: center;
  margin: 3.5rem 0 1.2rem;
  color: ${colors.sand};
`
const Description = styled.p<any>`
  ${GoodSansB2}
  text-align: center;
  margin-bottom: 2.2rem;
  color: ${colors.sand};
  max-width: 736px;
`
